import '.bn{position:relative;}.ssr-plugin'
import '.z{width:100%;}.ssr-plugin'
import '.g3{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.k{flex-direction:column;}.ssr-plugin'
import '.e{justify-content:center;}.ssr-plugin'
import '.c7{align-items:flex-start;}.ssr-plugin'
import '.j{padding:2rem;}.ssr-plugin'
import '.cn{background:var(--shades-white);}.ssr-plugin'
import '.aa{overflow:hidden;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.ip{top:50%;}.ssr-plugin'
import '.iq{right:1rem;}.ssr-plugin'
import '.ir{transform:translateY(-50%);}.ssr-plugin'
import '.is{width:120px;}.ssr-plugin'
import '.it{height:120px;}.ssr-plugin'
import '.iu{z-index:0;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.ho{z-index:1;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.iv{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bn z g3 d k e c7 j cn aa"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="a6 ip iq ir is it iu d l e"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bn ho d k c7 aj iv"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
